(() => {
  if (window.lfProductExperienceBound) return;
  window.lfProductExperienceBound = true;

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('details.lf-managed-real-life-photos a');
    if (!link || !link.querySelector('img')) return;
    const productInfo = link.closest('product-info[id^="MainProduct-"]');
    if (!productInfo || !customElements.get('product-modal')) return;
    const modal = document.getElementById(`LFReferencePhotoModal-${productInfo.dataset.section}`);
    const gallery = modal?.querySelector('[role="document"]');
    if (!gallery || typeof modal.show !== 'function') return;

    const links = Array.from(productInfo.querySelectorAll('details.lf-managed-real-life-photos a')).filter((item) => {
      if (!item.querySelector('img')) return false;
      try {
        return ['https:', 'http:'].includes(new URL(item.href, document.baseURI).protocol);
      } catch (_) {
        return false;
      }
    });
    if (!links.includes(link)) return;
    const fragment = document.createDocumentFragment();
    links.forEach((item, index) => {
      const image = item.querySelector('img').cloneNode(false);
      const mediaId = `lf-reference-${productInfo.dataset.section}-${index}`;
      item.setAttribute('data-media-id', mediaId);
      image.setAttribute('data-media-id', mediaId);
      image.removeAttribute('id');
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = item.href;
      image.loading = item === link ? 'eager' : 'lazy';
      image.style.maxWidth = '100%';
      image.style.height = 'auto';
      fragment.appendChild(image);
    });
    gallery.replaceChildren(fragment);
    modal.show(link);
    event.preventDefault();
  });
})();
